import * as actionCreators from './../../actions';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useNavigate } from "react-router-dom";
import { Alert, Fade } from "react-bootstrap";
import Inputs from "../../Components/Inputs";
import SpinnerLoading from "../../Components/SpinnerLoading";
import { options, params, url } from "../../actions/webServices";
import axios from "axios";
import useLoading from "../../hooks/useLoading";
import useError from '../../hooks/useError';
import { useEffect } from 'react';
import { validateDate, nextQuoteStep } from '../../utilities';



function Pets({ codpmpol, pets, user, company }) {
    const { isLoading, showLoading } = useLoading();
    const { showError, error } = useError();
    const navigate = useNavigate();

    const formattedDate = (date) => {
        if (!date) return;
        let newFormatted = date.split('/')[1] + '/' + date.split('/')[0] + '/' + date.split('/')[2];
        return newFormatted;
    };

    const handleSubmit = async () => {
        try {
            if (!pets.name || pets.name.length < 2) {
                showError('Revise el nombre de la mascota');
                return;
            }
            if (!pets.type) {
                showError('Revise el tipo de mascota');
                return;
            }
            if (!pets.birthdate || !validateDate(pets.birthdate, "2000")) {
                showError('Revise la fecha de nacimiento');
                return;
            };
            showLoading(true);
            params.set('opcpm', "Pets");
            params.set('codpmpol', codpmpol);
            // params.set('test', true);
            params.set('nommasc', pets.name);
            params.set('anomasc', formattedDate(pets.birthdate));
            params.set('codmasc', pets.type);
            const { data } = await axios.post(url, params, options);
            showLoading(false);
            if (!data) {
               showError('Hubo un error en el servidor. Intente más tarde');
               return;
            }
            navigate(nextQuoteStep(company, user?.codsuc));
        } catch (error) {
            showError(error);
        };
    };

    useEffect(() => {
        showError('');
    }, [pets]);

    return (
        <div>
            <Fade appear in>
                <div className={`qs qsmargin`}>
                    <div className="container max-shadow">
                        <div className='d-flex flex-column m-0 mx-0 mb-4 scroll-off'>
                            <h1 className='text-start mx-0 mt-3 fs-5 color-title-blue'>DATOS DE MASCOTA</h1>
                            <p className='m-0 fw-semibold color-title-blue'>Presupuesto n° {codpmpol}</p>
                        </div>
                        <div className="qs-inputs row row-cols-2">
                            <>
                                <Inputs
                                    title={"Nombre de mascota"}
                                    name={'name'}
                                    step={'pets'}
                                    value={pets.name}
                                />
                                <Inputs
                                    title={"Fecha de nacimiento aproximada"}
                                    name={'birthdate'}
                                    step={'pets'}
                                    type={'date'}
                                    value={pets.birthdate}
                                />
                                <Inputs
                                    title={"Tipo de mascota"}
                                    name={'type'}
                                    type={'select'}
                                    step={'pets'}
                                    options={[{ value: '0', label: 'Perro' }, { value: '1', label: 'Gato' }]}
                                    value={pets.type}
                                />
                            </>
                        </div>
                        {
                            error &&
                            <Alert className='mt-2' variant={'danger'}>
                                {error}
                            </Alert>
                        }
                        <div className='row flexend'>
                            <div className="col-sm-6 col-lg-4 offset-lg-4">

                                {
                                    isLoading ?
                                        <SpinnerLoading />
                                        :
                                        <Inputs
                                            type={'button'}
                                            title="Continuar"
                                            onClick={handleSubmit}
                                        />
                                }
                            </div>
                        </div>
                    </div>
                    {/* <div>
              {
                error &&
                <Alert className='mt-2' variant={'danger'}>
                  {mensaje}
                </Alert>
              }
            </div>
            <div className='row flexend'>
              <div className="col-sm-6 col-lg-4 offset-lg-4">
                <Inputs
                  type={'button'}
                  title="Continuar"
                  onClick={handleSubmit}
                />
              </div>*/}
                </div>
                {/* </div> */}
            </Fade>
        </div>
    );
};



function mapStateToProps(state) {
    return {
        codpmpol: state.mainReducer.codpmpol,
        pets: state.mainReducer.pets,
        user: state.mainReducer.user,
        company: state.mainReducer.company,
    };
};

const mapDispatchToProps = function (dispatch) {
    return bindActionCreators(actionCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Pets);

